import { useEffect, useState } from "react";
import { GraduationCap, Users, CreditCard, AlertCircle, CalendarDays, School, UserCheck, XCircle, CheckCircle2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { rupiah, YAYASAN } from "../lib/constants";
import { PageTitle, StatCard, Card, Loading } from "../components/Shared";

const TITLE = { admin: "Dashboard Admin", koordinator: "Dashboard Koordinator Pendampingan", guru: "Dashboard Guru", ortu: "Dashboard Orangtua" };

export default function Dashboard() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <Loading />;
  const role = user.role;
  return (
    <div data-testid={`dashboard-${role}`}>
      <PageTitle title={TITLE[role]} testId="dashboard-title" />
      <Card className="p-8 sm:p-10 text-center mb-6 relative overflow-hidden">
        <div className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-emerald-600 via-emerald-400 to-orange-400" />
        <img src="/logo.webp" alt="Logo" className="h-24 w-24 mx-auto object-contain" />
        <h2 data-testid="dashboard-welcome" className="mt-4 text-2xl sm:text-3xl font-extrabold text-slate-900">Selamat Datang, {user.nama}</h2>
        <p className="text-slate-500 mt-1">{YAYASAN}</p>
      </Card>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 stagger">
        {(role === "admin" || role === "koordinator") && <>
          <StatCard icon={GraduationCap} value={d.siswa} label="Siswa Pendampingan Aktif" testId="stat-siswa" />
          <StatCard icon={Users} value={d.guru} label="Guru Pendamping Aktif" tone="sky" testId="stat-guru" />
          <StatCard icon={CreditCard} value={rupiah(d.spp_bulan_ini)} label={`SPP Dibayarkan Bulan Ini (${d.spp_count} transaksi)`} tone="orange" testId="stat-spp" />
          <StatCard icon={AlertCircle} value={d.kendala_pending} label="Kendala Pending" tone="rose" testId="stat-kendala" />
        </>}
        {role === "guru" && <>
          <div className="sm:col-span-2"><StatCard wrap icon={GraduationCap} value={d.siswa?.nama || "Belum ada"} label="Siswa Pendampingan" testId="stat-siswa" /></div>
          <div className="sm:col-span-2"><StatCard wrap icon={School} value={d.siswa?.sekolah || "-"} label="Sekolah Siswa" tone="sky" testId="stat-sekolah" /></div>
          <StatCard icon={AlertCircle} value={d.kendala_saya} label="Kendala Saya (pending)" tone="rose" testId="stat-kendala" />
        </>}
        {role === "ortu" && <>
          <div className="sm:col-span-2"><StatCard wrap icon={UserCheck} value={d.guru?.nama || "Belum ditentukan"} label="Guru Pendamping" testId="stat-guru" /></div>
          <StatCard icon={CheckCircle2} value={d.hadir} label="Hadir Bulan Ini" tone="emerald" testId="stat-hadir" />
          <StatCard icon={XCircle} value={d.tidak_hadir} label="Tidak Hadir Bulan Ini" tone="rose" testId="stat-tidak-hadir" />
        </>}
      </div>
      <Card className="mt-6 px-6 py-4 flex items-center justify-center gap-2 text-sm text-slate-700 font-medium" data-testid="dashboard-date"><CalendarDays size={16} className="text-emerald-600" /> {d.tanggal}</Card>
    </div>
  );
}
